import React, { useEffect, useState } from 'react';
import AdminProductsPage from './index';
import MobileAdminProductsPage from './mobile';

export default function ResponsiveAdminProductsPage(props) {
  const [mobile, setMobile] = useState(() => window.matchMedia('(max-width: 991.98px)').matches);
  useEffect(() => {
    const media = window.matchMedia('(max-width: 991.98px)');
    let observer;
    const update = () => {
      // Rotation must not discard an open editor or a mutation in progress.
      if (document.querySelector('.modal.show')) {
        if (!observer) {
          observer = new MutationObserver(update);
          observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style'],
          });
        }
        return;
      }
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      setMobile(media.matches);
    };
    update();
    media.addListener(update);
    return () => {
      media.removeListener(update);
      if (observer) observer.disconnect();
    };
  }, []);
  // Mount one version: hidden desktop forms must not issue requests or own mobile state.
  return mobile ? <MobileAdminProductsPage {...props} /> : <AdminProductsPage {...props} />;
}
